/* ============================================================
   MAGICFX — Custom Printed Confetti Calculator
   DATA FILE — confetti-data.js

   Dit is het enige bestand dat je hoeft aan te passen.
   De calculator (confetti-calculator.html) laadt dit bestand in.

   INHOUD:
   1.  SETTINGS          — algemene instellingen (bedrijf, mail, BTW)
   2.  TEXTS             — alle zichtbare teksten en labels
   3.  METALLICS         — metallic kleurenpalet
   4.  PRODUCTS          — alle artikelen met verkoopprijzen per staffel
   5.  LEAD_NL           — doorlooptijden Thijsen + Snep (NL)
   6.  SUP               — leveranciersinstellingen en levertijden
   7.  TOOLING_COST      — stansmeskosten
   8.  TEMPLATES         — downloadlinks voor artwork templates
   9.  SHAPES            — shape-opties (labels + subteksten)
   10. CTYPES            — kleurtype-opties
   11. SIDES             — bedrukking-opties
   ============================================================ */


// ── 1. SETTINGS ──────────────────────────────────────────────
const SETTINGS = {
  company: {
    name:    'MAGICFX B.V.',
    address: 'Schouwrooij 27',
    city:    '5281 RE Boxtel',
    country: 'Netherlands',
    email:   'support@magicfx.com',
    kvk:     '',        // ← invullen
    vat:     '',        // ← invullen
  },
  support_email:  'roel.vanoers@magicfx.com',  // support/inkoop mail ontvangt offerte
  quote_validity: 30,                      // dagen dat een offerte geldig is
  min_kg:         10,                      // minimale bestelgrootte in kg
};


// ── 2. TEXTS — alle zichtbare teksten ────────────────────────
const TEXTS = {
  // Paginatitel + intro
  page_eyebrow:  'Custom printed confetti',
  page_title:    'Build your order.',
  page_lede:     'Configure your custom confetti step by step. Your best price is calculated automatically based on shape, print, quantity and delivery.',

  // Stapnamen
  step_shape:    'Shape.',
  step_colour:   'Colour type.',
  step_sides:    'Print sides.',
  step_artwork:  'Upload your artwork.',
  step_qty:      'Quantity.',
  step_delivery: 'Delivery.',
  step_details:  'Your details.',

  // Stap subteksten
  sub_shape:    'Choose the shape of your confetti pieces.',
  sub_colour:   'Choose your colour and print method.',
  sub_sides:    'Print your artwork on one or both sides.',
  sub_qty:      'Minimum order 10 kg. Price per kilo decreases at higher quantities.',
  sub_delivery: 'Choose your production time. Shipping to your location is additional and depends on your delivery address.',
  sub_details:  'Fill in your details so we can send you the quote and follow up on your order.',

  // Kleurtype info-boxen
  info_single:   '<strong>Single colour (CMYK)</strong> — One colour printed on a white background. Supply your artwork with your colour as a CMYK value.',
  info_full:     '<strong>Full colour (CMYK)</strong> — Supply your artwork as a CMYK file. Any colour combination is possible.',
  info_premium:  '<strong>Premium colour matching</strong> — For exact brand colour reproduction. Available as Pantone spot colour. An additional fee applies on top of the standard print price; we\'ll confirm the exact surcharge after reviewing your order.',
  info_metallic: '<strong>Metallic</strong> — No print. Choose from MAGICFX fixed metallic colours below. Produced in China — no custom colour matching available.',

  // Artwork upload
  upload_custom_metallic:  'Upload your die-cut shape outline as a vector PDF. No artwork needed — the metallic colour is applied to the shape as a whole. Read the shape requirements above first.',
  upload_custom:           'Upload your die-cut outline as a vector PDF. Read the shape requirements above first.',
  upload_rectangle:        'Download the template, specify your dimensions, place your artwork and upload below. Any rectangular or square size is possible — no die cost applies.',
  upload_standard:         'Download the template for your shape, place your artwork within the bleed area, and upload the file below.',
  upload_zone_primary:     'Drop your artwork here, or click to browse',
  upload_zone_secondary:   'PDF, AI or EPS · max 20 MB',
  upload_template_cta:     'Your design will be reviewed by our team.',
  review_custom:           'After submitting, a MAGICFX specialist checks your die-cut and confirms feasibility within 1 business day.',
  review_standard:         'After submitting, our team verifies your artwork fits the template and confirms production within 1 business day.',

  // Die-cut richtlijnen
  die_ok_title:  'Works well.',
  die_nok_title: 'Cannot be cut.',
  die_ok_rule:   'Smooth curves · rounded corners · min. radius <strong>2 mm</strong> · min. width <strong>3 mm</strong>.',
  die_nok_rule:  'Sharp tips · narrower than <strong>3 mm</strong> · internal cutouts.',

  // Template download
  template_intro: 'Download the print template for your shape.',
  template_sub:   'Place your artwork within the bleed area and upload the completed file below.',
  template_btn:   '↓ Download template',

  // Review notice (support team)
  review_notice_title_custom:   'Your shape will be reviewed by our team.',
  review_notice_title_standard: 'Your artwork will be checked by our team.',

  // Result panel
  result_label:     'YOUR PRICE',
  result_cta:       'Continue to quote',
  result_pending:   'Complete the steps above to see your price.',
  result_on_request:'On request',

  // Price breakdown
  breakdown_confetti:   'Confetti',
  breakdown_die_label:  'Die-cut blade',
  breakdown_die_note:   '(one-time · owned by you · reorders free)',
  breakdown_total:      'Total first order',

  // Stansmesnotitie (extras onder prijs)
  die_notice: 'Die-cut blade (one-time): {price} — the die belongs to you and is stored at our factory. Only charged once per shape.',

  // Formulier
  form_name:    'Full name',
  form_email:   'Email address',
  form_company: 'Company name',
  form_vat:     'VAT number',
  form_address: 'Delivery address',
  form_notes:   'Additional notes',
  form_notes_placeholder: 'Deadline, special requirements, questions…',
  form_submit:  'Send quote request',
  form_note:    'You\'ll receive a confirmation email. We\'ll get back to you within 1 business day.',

  // Success
  success_title: 'Quote request sent.',

  // Footer
  footer_note: 'Prices per kg · excl. VAT · die-cut blade €795 one-time (custom shapes only)',

  // >500 kg melding
  over_max_kg: 'Lead time on request (> 500 kg — contact us)',

  // Delivery: contact us melding bij klikken op TBD
  tbd_hint: 'Lead time for > 500 kg is not yet available. Please contact us directly.',
};


// ── 3. METALLICS — kleurenpalet ──────────────────────────────
// hex: exacte kleurcode van het MAGICFX swatch (pixel-sampled)
const METALLICS = [
  {id:'m-gold',   name:'Gold',      hex:'#D49A06'},
  {id:'m-silver', name:'Silver',    hex:'#C0C0C0'},
  {id:'m-red',    name:'Red',       hex:'#CC2222'},
  {id:'m-blue',   name:'Blue',      hex:'#3468B1'},
  {id:'m-green',  name:'Green',     hex:'#2D945A'},
  {id:'m-rose',   name:'Rose gold', hex:'#C9877A'},
];


// ── 4. PRODUCTS ───────────────────────────────────────────────
// shape  : id uit SHAPES
// sides  : 'none' | 'single' | 'double'
// colour : 'single' | 'full' | 'metallic'  (premium = full voor lookup)
// sup    : 'thijsen' | 'snep' | 'wuxi'
// days   : alleen voor Wuxi — pinned aan specifieke levertijd (lucht=10, zee=40)
// tiers  : [{kg: minimumKg, p: verkoopprijs/kg}, ...]
//          geldt VANAF dat kg-niveau tot de volgende tier

const PRODUCTS = [
  // ── Custom – metallic, no print (Wuxi — air freight only) ─
  {shape:'custom', sides:'none', colour:'metallic', sup:'wuxi', days:10,
   tiers:[{kg:10,p:35.00},{kg:50,p:27.50},{kg:100,p:24.50},{kg:250,p:24.50},{kg:500,p:24.50}]},

  // ── Custom – single colour, no print (Wuxi — air freight only)
  {shape:'custom', sides:'none', colour:'single', sup:'wuxi', days:10,
   tiers:[{kg:10,p:32.50},{kg:50,p:25.00},{kg:100,p:22.50},{kg:250,p:22.50},{kg:500,p:22.50}]},

  // ── Custom – printed (Snep) ───────────────────────────────
  {shape:'custom', sides:'single', colour:'single', sup:'snep',
   tiers:[{kg:10,p:42.50},{kg:50,p:27.50},{kg:100,p:24.50},{kg:250,p:22.50},{kg:500,p:24.50}]},
  {shape:'custom', sides:'double', colour:'single', sup:'snep',
   tiers:[{kg:10,p:47.50},{kg:50,p:32.50},{kg:100,p:29.50},{kg:250,p:29.50},{kg:500,p:29.50}]},
  {shape:'custom', sides:'single', colour:'full',   sup:'snep',
   tiers:[{kg:10,p:60.00},{kg:50,p:37.50},{kg:100,p:32.50},{kg:250,p:32.50},{kg:500,p:32.50}]},
  {shape:'custom', sides:'double', colour:'full',   sup:'snep',
   tiers:[{kg:10,p:75.00},{kg:50,p:42.50},{kg:100,p:37.50},{kg:250,p:37.50},{kg:500,p:37.50}]},

  // ── 55 × 17 mm (Thijsen) ─────────────────────────────────
  {shape:'55x17', sides:'single', colour:'single', sup:'thijsen',
   tiers:[{kg:10,p:32.50},{kg:50,p:17.50},{kg:100,p:15.00},{kg:250,p:13.00},{kg:500,p:11.50}]},
  {shape:'55x17', sides:'double', colour:'single', sup:'thijsen',
   tiers:[{kg:10,p:35.00},{kg:50,p:20.00},{kg:100,p:17.50},{kg:250,p:15.50},{kg:500,p:14.00}]},
  {shape:'55x17', sides:'single', colour:'full',   sup:'thijsen',
   tiers:[{kg:10,p:42.50},{kg:50,p:22.50},{kg:100,p:22.50},{kg:250,p:14.50},{kg:500,p:13.00}]},
  {shape:'55x17', sides:'double', colour:'full',   sup:'thijsen',
   tiers:[{kg:10,p:45.00},{kg:50,p:25.00},{kg:100,p:20.00},{kg:250,p:17.50},{kg:500,p:16.50}]},

  // ── Rounds 55 mm (Thijsen) ───────────────────────────────
  {shape:'rounds', sides:'single', colour:'single', sup:'thijsen',
   tiers:[{kg:10,p:42.50},{kg:50,p:27.50},{kg:100,p:24.50},{kg:250,p:22.50},{kg:500,p:21.00}]},
  {shape:'rounds', sides:'double', colour:'single', sup:'thijsen',
   tiers:[{kg:10,p:47.50},{kg:50,p:32.50},{kg:100,p:29.50},{kg:250,p:27.00},{kg:500,p:25.50}]},
  {shape:'rounds', sides:'single', colour:'full',   sup:'thijsen',
   tiers:[{kg:10,p:60.00},{kg:50,p:37.50},{kg:100,p:32.50},{kg:250,p:28.50},{kg:500,p:25.50}]},
  {shape:'rounds', sides:'double', colour:'full',   sup:'thijsen',
   tiers:[{kg:10,p:75.00},{kg:50,p:42.50},{kg:100,p:37.50},{kg:250,p:34.50},{kg:500,p:18.97}]},

  // ── Hearts 55 mm (Thijsen) ───────────────────────────────
  {shape:'hearts', sides:'single', colour:'single', sup:'thijsen',
   tiers:[{kg:10,p:42.50},{kg:50,p:27.50},{kg:100,p:24.50},{kg:250,p:22.50},{kg:500,p:21.00}]},
  {shape:'hearts', sides:'double', colour:'single', sup:'thijsen',
   tiers:[{kg:10,p:47.50},{kg:50,p:32.50},{kg:100,p:29.50},{kg:250,p:27.00},{kg:500,p:25.50}]},
  {shape:'hearts', sides:'single', colour:'full',   sup:'thijsen',
   tiers:[{kg:10,p:60.00},{kg:50,p:37.50},{kg:100,p:32.50},{kg:250,p:28.50},{kg:500,p:25.50}]},
  {shape:'hearts', sides:'double', colour:'full',   sup:'thijsen',
   tiers:[{kg:10,p:75.00},{kg:50,p:42.50},{kg:100,p:37.50},{kg:250,p:34.50},{kg:500,p:18.97}]},

  // ── Bank notes 150×75 mm (Thijsen) ───────────────────────
  // Always double sided, full colour only
  {shape:'banknotes', sides:'double', colour:'full', sup:'thijsen',
   tiers:[{kg:10,p:40.00},{kg:50,p:22.50},{kg:100,p:18.50},{kg:250,p:15.50},{kg:500,p:14.00}]},

  // ── Custom rectangle — own dimensions (Thijsen) ───────────
  // Rectangular/square only · no die cost · same pricing as Bank notes
  {shape:'rectangle', sides:'single', colour:'single', sup:'thijsen',
   tiers:[{kg:10,p:35.00},{kg:50,p:18.50},{kg:100,p:16.00},{kg:250,p:14.00},{kg:500,p:12.50}]},
  {shape:'rectangle', sides:'double', colour:'single', sup:'thijsen',
   tiers:[{kg:10,p:38.00},{kg:50,p:21.00},{kg:100,p:18.50},{kg:250,p:16.50},{kg:500,p:15.00}]},
  {shape:'rectangle', sides:'single', colour:'full',   sup:'thijsen',
   tiers:[{kg:10,p:40.00},{kg:50,p:22.50},{kg:100,p:18.50},{kg:250,p:15.50},{kg:500,p:14.00}]},
  {shape:'rectangle', sides:'double', colour:'full',   sup:'thijsen',
   tiers:[{kg:10,p:43.00},{kg:50,p:25.00},{kg:100,p:21.00},{kg:250,p:18.00},{kg:500,p:16.50}]},
];


// ── 5. LEAD_NL — doorlooptijden Thijsen + Snep ───────────────
// Drie categorieën:
//   cutOnly  — 55×17mm, Bank notes, Custom rectangle (alleen snijden)
//   punch    — Hearts, Rounds (stansen, stansmachine al aanwezig)
//   custom   — Custom shape (nieuw stansmachine: punch + 10 werkdagen)
//
// [maxKg, cutOnly, punch, custom]  — null = nader te bepalen → "contact us"
const LEAD_NL = {
  tiers: [
    [10,    7,  10,  20],
    [50,    7,  11,  21],
    [100,   8,  12,  22],
    [250,   9,  15,  25],
    [500,  20,  20,  30],
    // >500 kg → contact us (geen regel nodig — valt buiten find())
  ],
  get(shape, kg) {
    const tier = this.tiers.find(t => kg <= t[0]);
    if (!tier) return [{days:999, label: TEXTS.over_max_kg}];
    let days;
    if (['55x17','banknotes','rectangle'].includes(shape)) days = tier[1];
    else if (['rounds','hearts'].includes(shape))          days = tier[2];
    else if (shape === 'custom')                           days = tier[3];
    else                                                   days = tier[2];
    if (days == null) return [{days:999, label: TEXTS.over_max_kg}];
    return [{days, label:`Ready for shipment within ${days} working days`}];
  }
};


// ── 6. SUP — leveranciersinstellingen ────────────────────────
const SUP = {
  thijsen: (kg, shape) => LEAD_NL.get(shape, kg),
  snep:    (kg, shape) => LEAD_NL.get(shape, kg),
  wuxi:    () => [
    {days:10, label:'Ready for shipment within 10 working days'},
  ],
};


// ── 7. TOOLING_COST ───────────────────────────────────────────
// Stansmeskosten — eenmalig, eigendom klant, opgeslagen bij fabriek
// Alleen voor 'custom' shape. Andere shapes: geen stansmeskosten.
const TOOLING_COST = 795;
const TOOLING = {thijsen: TOOLING_COST, snep: TOOLING_COST, wuxi: TOOLING_COST};


// ── 8. TEMPLATES — artwork download links ────────────────────
// Vervang 'file' door de echte URL of relatief pad op je server/Shopify CDN
const TEMPLATES = {
  '55x17':      {label:'55 × 17 mm template',        file:'template_55x17mm.pdf'},
  'rounds':     {label:'Rounds 55 mm template',       file:'template_rounds55mm.pdf'},
  'hearts':     {label:'Hearts 55 mm template',       file:'template_hearts55mm.pdf'},
  'banknotes':  {label:'Bank notes template',         file:'template_banknotes150x75mm.pdf'},
  'rectangle':  {label:'Custom rectangle template',   file:'template_custom_rectangle.pdf'},
};


// ── 9. SHAPES ─────────────────────────────────────────────────
const SHAPES = [
  {id:'55x17',      label:'55 × 17 mm',         sub:'Rectangle'},
  {id:'rounds',     label:'Rounds 55 mm',        sub:'Circle'},
  {id:'hearts',     label:'Hearts 55 mm',        sub:'Heart'},
  {id:'banknotes',  label:'Bank notes',          sub:'150 × 75 mm'},
  {id:'rectangle',  label:'Custom rectangle',    sub:'Your own size, no die cost'},
  {id:'custom',     label:'Custom shape',        sub:'Your own die cut'},
];


// ── 10. CTYPES — kleurtype tiles ─────────────────────────────
const CTYPES = [
  {id:'single',   label:'Single colour', sub:'1 colour CMYK'},
  {id:'full',     label:'Full colour',   sub:'CMYK artwork'},
  {id:'premium',  label:'Premium',       sub:'Pantone exact match'},
  {id:'metallic', label:'Metallic',      sub:'Fixed colours, no print'},
];


// ── 11. SIDES — bedrukking tiles ─────────────────────────────
const SIDES = [
  {id:'single', label:'Single sided', sub:'Artwork on 1 side'},
  {id:'double', label:'Double sided', sub:'Artwork on both sides'},
];
